// Styles
import '@mdi/font/css/materialdesignicons.css';
// import '../../../frontend/node_modules/vuetify/styles';

// Vuetify
import { md3 } from 'vuetify/blueprints';
import {
    createVuetify,
} from 'vuetify';

export default createVuetify({
    blueprint: md3,
    theme: {
        themes: {
            light: {
                dark: false,
                colors: {
                    navigation: '#37474F',
                    primary: '#0373ff',
                    rose_high_light: '#fff0f2',
                },
            },
            dark: {
                dark: true,
                colors: {
                    navigation: '#37474F',
                    primary: '#0550ae',
                    rose_high_light: '#462023',
                },
            },
            navigation: {
                dark: true,
                colors: {
                    navigation: '#37474F',
                    surface: '#37474F',
                    primary: '#0550ae',
                },
            },
        },
    },
});
